import React from "react";

import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css';
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search} from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit';

const { SearchBar } = Search;
SearchBar.srText = '搜尋這張表'

const Table = ({data, columns, rowEvents,fileName,keyField,download}) => {
    return (<ToolkitProvider
    keyField={keyField}
    data={ data }
    columns={ columns }
    search
  >{props => (
    <>
     <SearchBar srText="" style={{width:'20%'}} { ...props.searchProps } />
      <BootstrapTable
        {...props.baseProps}
        hover
        bootstrap4
        pagination={paginationFactory({ sizePerPage: 10 })}
        rowEvents={rowEvents}
      />
      <div className='result-import'>
        <div><h6>查詢結果共 {data.length} 筆</h6></div>
        {fileName ? <div className="btn btn-success" onClick={download}>匯出Excel</div> : ""}
      </div>
    </>
  )
    }

  </ToolkitProvider>
  )
}

export default Table;